var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXAttach = function SvgXAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x-attach_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.222 3H4.778C3.79 3 3 3.791 3 4.778v12.444A1.778 1.778 0 0 0 4.778 19h12.444A1.778 1.778 0 0 0 19 17.222V4.778A1.778 1.778 0 0 0 17.222 3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 16.333h-2.333L10.5 11.9l-2.567 4.433H5.6L9.333 10.5 5.6 4.667h2.333L10.5 9.1l2.567-4.433H15.4L11.667 10.5m7-10.5H2.333A2.325 2.325 0 0 0 0 2.333v16.334A2.333 2.333 0 0 0 2.333 21h16.334A2.333 2.333 0 0 0 21 18.667V2.333A2.333 2.333 0 0 0 18.667 0Z",
    fill: "#005F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "x-attach_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgXAttach;